module.exports = __webpack_public_path__ + "static/media/smarthygiene_ci3.e93042d7.png";